import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonOffTimeService } from 'src/app/Service/Person/PersonOffTime.service';

@Component({
  selector: 'app-PersonOffTimeAdd',
  templateUrl: './PersonOffTimeAdd.component.html',
  styleUrls: ['./PersonOffTimeAdd.component.css']
})
export class PersonOffTimeAddComponent implements OnInit {

  Token: String = ""

  HourList=[]
  MinList=[]

  constructor(
    private PersonOff_Service: PersonOffTimeService,

    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,

  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.HourList=Array(24).fill(1).map((x, i) => i);
    this.MinList=Array(60).fill(1).map((x, i) => i);

    this.AddNewOfftime = new FormGroup({
      id: new FormControl(),
      endDate_Min: new FormControl("0"),
      endDate_Hour: new FormControl("0"),
      startDate_Min: new FormControl("0"),
      startDate_Hour: new FormControl("0"),
      requestDate: new FormControl(),
      dsc: new FormControl(null, Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token, 2209).subscribe(
      data => {

      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewOfftime: FormGroup;



  get_Form_requestDate() {
    return this.AddNewOfftime.get('requestDate') as FormControl;
  }

  get_Form_dsc() {
    return this.AddNewOfftime.get('dsc') as FormControl;
  }

  get_Form_endDate_Hour() {
    return this.AddNewOfftime.get('endDate_Hour') as FormControl;
  }
  get_Form_endDate_Min() {
    return this.AddNewOfftime.get('endDate_Min') as FormControl;
  }
  get_Form_startDate_Min() {
    return this.AddNewOfftime.get('startDate_Min') as FormControl;
  }
  get_Form_startDate_Hour() {
    return this.AddNewOfftime.get('startDate_Hour') as FormControl;
  }

  //#endregion




  InProccessing: boolean = false


  SubmitAddNewOfftime() {
    this.InProccessing = true
    this.PersonOff_Service.AddOfftime(
      this.get_Form_startDate_Hour().value+':'+this.get_Form_startDate_Min().value,
      this.get_Form_endDate_Hour().value+':'+this.get_Form_endDate_Min().value,
      this.get_Form_dsc().value,
      this.get_Form_requestDate().value,
      this.Token).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("You already have a request for this time range.")
          }
          else if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("Check the leave time range.")
          }
          else if (data.id == -3) {
            this.Alertify_Service.ErrorMessage("No active workflow has been selected for hourly leave.")
          }
          else if (data.id == -4) {
            this.Alertify_Service.ErrorMessage("System error.")
          }
          else if (data.id == -5) {
            this.Alertify_Service.ErrorMessage("You do not have a position in the organizational chart.")
          }
          else {

            this.AddNewOfftime.reset()

            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
  }

}
